import styled, { css } from 'styled-components';
"use strict";
const Container = styled.div`
  display: inline-flex;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  ${({
  $size
}) => css`
    width: ${$size}px;
    height: ${$size}px;
  `}
`;
export { Container };
//# sourceMappingURL=Avatar.styles.mjs.map
